module.exports = __webpack_public_path__ + "img/banner-contact-company.39b392dd.png";